import type { ColumnType } from 'antd/es/table';
import { CryptoFlag } from 'shared/src/CryptoFlag';
import { CryptoNetworkIcon } from 'shared/src/CryptoNetworkIcon';

import { hasValue } from 'utils/hasValue';

import type { GetCryptoExchanges200DataItem } from 'api';

import { FormattedDateTime } from '@molecules/FormattedDateTime';

import { fallbackTradeStatusColor, tradeStatusColor } from './tradeStatusColor';

import { StatusBadge } from '../shared/StatusBadge';

const colSpacing = {
  onHeaderCell: () => ({ style: { padding: '8px 16px' } }),
  onCell: () => ({ style: { padding: '8px 16px' } })
};

export const tradeColumns: ColumnType<GetCryptoExchanges200DataItem>[] = [
  {
    ...colSpacing,
    key: 'from_currency',
    width: 5,
    render: (_, record) => (
      <div className="relative inline-flex">
        <CryptoFlag
          cryptoCode={record.from_currency ?? ''}
          className="size-6"
        />
        <CryptoNetworkIcon
          network={record.from_network ?? ''}
          className="absolute -bottom-0.5 -right-0.5 size-3"
        />
      </div>
    )
  },
  {
    ...colSpacing,
    title: 'Amount',
    align: 'right',
    render: (_, record) => (
      <p className="font-medium">
        {record.formatted_from_amount
          ? `-${record.formatted_from_amount} ${record.from_currency}`
          : '-'}
      </p>
    )
  },
  {
    ...colSpacing,
    title: 'Received',
    align: 'right',
    render: (_, record) => (
      <p className="font-medium">
        {record.formatted_to_amount
          ? `${record.formatted_to_amount} ${record.to_currency}`
          : '-'}
      </p>
    )
  },
  {
    ...colSpacing,
    title: 'Date',
    dataIndex: 'created_at',
    key: 'created_at',
    align: 'right',
    render: (value: string) => <FormattedDateTime value={value} format="cet" />
  },
  {
    ...colSpacing,
    title: 'Status',
    align: 'right',
    key: 'status',
    render: (_, record) => {
      const status = record.status_histories?.at(0)?.status;

      if (!hasValue(status)) return null;

      return (
        <StatusBadge
          color={tradeStatusColor[status] ?? fallbackTradeStatusColor}
          statusText={status}
        />
      );
    }
  }
];
